import { render, staticRenderFns } from "./SnackbarNotification.vue?vue&type=template&id=4f0a2048&scoped=true"
import script from "./SnackbarNotification.vue?vue&type=script&lang=js"
export * from "./SnackbarNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0a2048",
  null
  
)

export default component.exports